export default {"src":"/_next/static/media/ico_triangle.bb6ac1d5.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};